// config stuff, loading modules from node_modules etc.
import BasicFormList from "./Classes/Plugins/BasicFormList";

require('./bootstrap');
require('./Libraries/FormHelpers');
require('./Libraries/ColumnSettings');

// basic imports
import Tabs from "./Classes/Plugins/Tabs";
import OrderBy from "./Classes/Plugins/OrderBy";
import SmallTabsHider from "./Classes/Plugins/SmallTabsHider";
import './Libraries/NavigationExtended';
import './Libraries/ElementToggler';

// autoloaders
import BaseLoader from './Classes/AutoLoaders/BaseLoader';
import TilesLoader from './Classes/AutoLoaders/TilesLoader';
import SplitLoader from './Classes/AutoLoaders/SplitLoader';

// plugins
import ExaminationCockpit from './Classes/Plugins/ExaminationCockpit';
import FacilitiesOverview from "./Classes/Plugins/FacilitiesOverview";
import FacilityDetails from "./Classes/Plugins/FacilityDetails";
import InspectionDocumentsList from "./Classes/Plugins/InspectionDocumentsList";
import InspectionInvoicesList from "./Classes/Plugins/InspectionInvoicesList";
import CertificationDetail from "./Classes/Plugins/CertificationDetail";
import UserProfile from './Classes/Plugins/UserProfile';
import SeminarDetails from "./Classes/Plugins/SeminarDetails";
import SeminarFuture from "./Classes/Plugins/SeminarFuture";
import SeminarHistory from "./Classes/Plugins/SeminarHistory";
import ContactForm from "./Classes/Plugins/ContactForm";
import FacilitiesSearch from "./Classes/Plugins/FacilitiesSearch";
import VehicleExaminationsSearch from "./Classes/Plugins/VehicleExaminationsSearch";
import VehicleExaminationsList from "./Classes/Plugins/VehicleExaminationsList";
import VehicleExaminationDetails from "./Classes/Plugins/VehicleExaminationDetails";
import VehicleListOverview from "./Classes/Plugins/VehicleListOverview";
import VehicleList from "./Classes/Plugins/VehicleList";
import VehicleDetails from "./Classes/Plugins/VehicleDetails";
import CarPoolsUpload from "./Classes/Plugins/CarPoolsUpload";
import CarPoolsList from "./Classes/Plugins/CarPoolsList";
import CarPoolsVehicleListOverview from "./Classes/Plugins/CarPoolsVehicleListOverview";
import CarPoolsVehicleList from "./Classes/Plugins/CarPoolsVehicleList";
import CarPoolsVehicleAssignments from "./Classes/Plugins/CarPoolsVehicleAssignments";
import CarPoolsVehicleExaminations from "./Classes/Plugins/CarPoolsVehicleExaminations";
import CarPoolsAssessmentsCreate from "./Classes/Plugins/CarPoolsAssessmentsCreate";
import CarPoolsAssessmentsList from "./Classes/Plugins/CarPoolsAssessmentsList";
import CarPoolsDamageAssessmentList from "./Classes/Plugins/CarPoolsDamageAssessmentList";
import CertificationList from "./Classes/Plugins/CertificationList";
import Appointments from "./Classes/Plugins/Appointments";
import CertProposalForm from "./Classes/Plugins/CertProposalForm"
import CommercialDocumentsList from "./Classes/Plugins/CommercialDocumentsList";
import AssignmentsList from "./Classes/Plugins/AssignmentsList";
import AssignmentsCreate from "./Classes/Plugins/AssignmentsCreate";
import StaticTilesHeightMatcher from "./Classes/Plugins/StaticTilesHeightMatcher";
import FacilityReportsList from "./Classes/Plugins/FacilityReportsList";
import FacilityReportsOverview from "./Classes/Plugins/FacilityReportsOverview";
import SwitchUserSimulation from "./Classes/Plugins/SwitchUserSimulation";
import InspectionAppointmentsList from "./Classes/Plugins/InspectionAppointmentsList";
import WheeldatabaseList from "./Classes/Plugins/WheeldatabaseList";


// BaseLoader is used for simple xhr requests e.g. the personal data header
new BaseLoader('[data-tncp-autoloader="base"]');

// TilesLoader is used to load and show tiles
new TilesLoader('[data-tncp-autoloader="tiles"]');

// SplitLoader is used to load and show elements from one datasource to multiple targets
_.forEach($('[data-tncp-autoloader="split"]'), (element) => {
    new SplitLoader(element);
});

// ExaminationCockpit is used on page "Prüfungsübersicht"
new ExaminationCockpit('[data-tncp-tabs-factory="ExaminationCockpit"]');

// FacilitiesOverview is used on page "Anlagenübersicht / Anlagenbestand"
new FacilitiesOverview('[data-tncp-plugin="FacilitiesOverview"]');

// Tabs is a general plugin to handle bigtabs and smaller tabs
window.tabs = new Tabs('[data-tncp-plugin="Tabs"]');

// FacilityDetails is used on the detail page for the facilities
new FacilityDetails('[data-tncp-tabs-factory="FacilityDetails"]');

// Inspection Documents is used on the inspection documents page
new InspectionDocumentsList('[data-tncp-plugin="InspectionDocumentsList"]');

// Inspection Invoices is used on the inspection documents page
new InspectionInvoicesList('[data-tncp-plugin="InspectionInvoicesList"]');

// Facility Reports List is used on the ZIN code page
new FacilityReportsList('[data-tncp-plugin="FacilityReportsList"]');

// Facility Reports List is used on the ZIN code page
new FacilityReportsOverview('[data-tncp-plugin="FacilityReportsOverview"]');

// CertificationDetail is used on the detail page of certifications
new CertificationDetail('[data-tncp-tabs-factory="CertificationDetail"]');

// Profile (edit profile, change password)
new UserProfile('[data-tncp-tabs-factory="Profile"]');

// Contact Form
new ContactForm('[data-tncp-plugin="ContactForm"]');

// Vehicle Examination List
new VehicleExaminationsList('[data-tncp-plugin="VehicleExaminationsList"]');

// Vehicle Examination Details
new VehicleExaminationDetails('[data-tncp-plugin="VehicleExaminationDetails"]');

// Vehicle List Overview
new VehicleListOverview('[data-tncp-tabs-factory="VehicleListOverview"]');

// Vehicle List
new VehicleList('[data-tncp-plugin="VehicleList"]');

// Vehicle Examination Details
new VehicleDetails('[data-tncp-plugin="VehicleDetails"]');

// Car Pools Upload
window.CarPoolsUpload = new CarPoolsUpload('[data-tncp-plugin="CarPoolsUpload"]');

// Car Pools List
new CarPoolsList('[data-tncp-plugin="CarPoolsList"]');

// Car Pools Vehicle Overview List
new CarPoolsVehicleListOverview('[data-tncp-tabs-factory="CarPoolsVehicleListOverview"]');

// Car Pools Vehicle List
new CarPoolsVehicleList('[data-tncp-plugin="CarPoolsVehicleList"]');

// Car Pools Vehicle CarPoolsVehicleDetail
new CarPoolsVehicleAssignments('[data-tncp-plugin="CarPoolsVehicleAssignments"]');

// Car Pools Vehicle CarPoolsVehicleDetail
new CarPoolsVehicleExaminations('[data-tncp-plugin="CarPoolsVehicleExaminations1"]');
new CarPoolsVehicleExaminations('[data-tncp-plugin="CarPoolsVehicleExaminations2"]');

// Car Pools Assignments Create
window.CarPoolsAssessmentsCreate = new CarPoolsAssessmentsCreate('[data-tncp-plugin="CarPoolsAssessmentsCreate"]');

// Car Pools Assignments List
new CarPoolsAssessmentsList('[data-tncp-plugin="CarPoolsAssessmentsList"]');

// Car Pools DamageAssessment List
new CarPoolsDamageAssessmentList('[data-tncp-plugin="CarPoolsDamageAssessmentList"]');

// Wheeldatabase List
new WheeldatabaseList('[data-tncp-plugin="WheeldatabaseList"]');

// Assignments List
new AssignmentsList('[data-tncp-plugin="AssignmentsList"]');

// Inspection Appointments List
new InspectionAppointmentsList('[data-tncp-plugin="InspectionAppointmentsList"]');

// Assignments Create
window.AssignmentsCreate = new AssignmentsCreate('[data-tncp-plugin="AssignmentsCreate"]');

// Basic Form List
new BasicFormList('[data-tncp-plugin="BasicFormList"]');

// SmallTabsHider is an "extension" for smaller tabs. It is used for responsive layout differences betweeen smaller and bigger layouts
_.forEach($('[data-tncp-plugin="SmallTabsHider"]'), (element) => {
    new SmallTabsHider(element);
});

// OrderBy is a plugin used for filterable / sortable elements like page "Anlagenbestand"
_.forEach($('[data-tncp-plugin="OrderBy"]'), (element) => {
    new OrderBy(element);
});


// SeminarDetails is used on the detail page for the facilities
new SeminarDetails('[data-tncp-tabs-factory="SeminarDetails"]');

// SeminarFuture
new SeminarFuture('[data-tncp-tabs-factory="SeminarFuture"]');

// SeminarHistory
new SeminarHistory('[data-tncp-tabs-factory="SeminarHistory"]');

// FacilitySearch
new FacilitiesSearch('[data-tncp-plugin="FacilitiesSearch"]');

// VehicleExaminationsSearch
new VehicleExaminationsSearch('[data-tncp-plugin="VehicleExaminationsSearch"]');

// Certifications: list
new CertificationList('[data-tncp-plugin="CertificationList"]');

// Appointments
new Appointments('[data-tncp-plugin="Appointments"]');

// CertProposalForm ("Angebot erhalten"-Formular)
new CertProposalForm('[data-certproposalform]');

new CommercialDocumentsList('[data-tncp-plugin="CommercialDocumentsList"]');

new StaticTilesHeightMatcher('[data-tncp-plugin="StaticTilesHeightMatcher"]');

new SwitchUserSimulation('[data-tncp-plugin="SwitchUserSimulation"]');
